import { render, staticRenderFns } from "./WineListTasting.vue?vue&type=template&id=35a2f145&"
import script from "./WineListTasting.vue?vue&type=script&lang=js&"
export * from "./WineListTasting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports